'use client';

import { LoggerType } from '../../../DI/dependencyInjection';
import { CommonDI } from '../../../DI/index';
import { DataLayerError } from './DataLayerError';
import { DataLayerEvent } from './DataLayerEvent';
import { DataLayerEventParams } from './DataLayerEventParams';
import { DataLayerKey } from './DataLayerKey';
import { DataLayerT2SKey } from './DataLayerT2SKey';

const DATA_LAYER_LOGGER_NAMESPACE = 'DataLayer';

export interface DataLayerManagerSpec {
    addVariable(name: DataLayerKey, value: string): void;

    addVariables(variables: Partial<Record<DataLayerKey, string>>): void;

    deleteVariable(name: DataLayerKey): void;

    trackEvent(eventName: DataLayerEvent, params: DataLayerEventParams): void;

    trackT2SEvent(params: Record<DataLayerT2SKey, string>): void;

    showPrivacyCenter(): void;
}

export class DataLayerManager implements DataLayerManagerSpec {
    public variables: Partial<Record<DataLayerKey, string | string[] | number>>;

    constructor() {
        this.variables = {
            [DataLayerKey.EnvChannel]: 'web',
            [DataLayerKey.EnvHeadless]: 'y',
        };
    }

    addVariable(name: DataLayerKey, value: string | string[] | number): void {
        try {
            this.variables[name] = value;
            window.tc_vars = this.variables;
        } catch (error) {
            CommonDI.get(LoggerType).error(DATA_LAYER_LOGGER_NAMESPACE, DataLayerError.addVariable, error);
        }
    }

    addVariables(variables: Partial<Record<DataLayerKey, string | string[] | number>>): void {
        try {
            this.variables = {
                ...this.variables,
                ...variables,
            };
            window.tc_vars = this.variables;
        } catch (error) {
            CommonDI.get(LoggerType).error(DATA_LAYER_LOGGER_NAMESPACE, DataLayerError.addVariables, error);
        }
    }

    deleteVariable(name: DataLayerKey): void {
        try {
            delete this.variables[name];
            window.tc_vars = this.variables;
        } catch (error) {
            CommonDI.get(LoggerType).error(DATA_LAYER_LOGGER_NAMESPACE, DataLayerError.deleteVariable, error);
        }
    }

    trackEvent(eventName: DataLayerEvent, params: DataLayerEventParams): void {
        try {
            window.tc_events_global(window, eventName, params);
        } catch (error) {
            CommonDI.get(LoggerType).error(DATA_LAYER_LOGGER_NAMESPACE, DataLayerError.trackEvent, error);
        }
    }

    trackT2SEvent(params: Record<DataLayerT2SKey, string>): void {
        try {
            window.T2S.click(params);
        } catch (error) {
            CommonDI.get(LoggerType).error(DATA_LAYER_LOGGER_NAMESPACE, DataLayerError.trackT2SEvent, error);
        }
    }

    showPrivacyCenter() {
        try {
            window.tC.privacyCenter.showPrivacyCenter();
        } catch (error) {
            CommonDI.get(LoggerType).error(DATA_LAYER_LOGGER_NAMESPACE, DataLayerError.showPrivacyCenter, error);
        }
    }
}
